export const NAVIGATION_CONFIG = {
  ROWS_VISIBLE: 6,        // Number of visible rows (configurable)
  MINUTES_PER_ROW: 1,     // Minutes of data per row (configurable)
  ROW_HEIGHT_PX: 60,     // Height of each navigation row in pixels (configurable)
  SCROLL_BEHAVIOR: 'smooth', // Scroll behavior
  LOAD_DELAY: 300,        // Delay before loading new rows (ms)
  PREFETCH_ROWS: 10,       // Number of rows to prefetch around visible area
  UNLOAD_DISTANCE: 100,     // Unload rows more than this many rows away (100 rows = 100 minutes buffer)
};

// Event type enum values (must match backend NavigationEventType)
export const NAVIGATION_EVENT_TYPES = {
  CardiacPause: 10,
  Bradycardia: 20,
  Tachycardia: 30,
  IrregularBeat: 40,
};

export const GRID_SPECS = {
  majorGridX: 200,  // 200ms (5mm at 25mm/s)
  minorGridX: 40,   // 40ms (1mm at 25mm/s)
  majorGridY: 0.5,  // 0.5mV
  minorGridY: 0.1,  // 0.1mV
  fixedYAxis: {
    min: -1,        // Fixed minimum Y-axis value in mV
    max: 1,         // Fixed maximum Y-axis value in mV
  },
  colors: {
    majorGrid: '#ffc0c0',     // Red grid lines
    minorGrid: '#ffe0e0',     // Light red grid
    ecgLine: '#0000ff',       // Blue ECG line
    viewWindow: 'rgba(0,0,0,0.3)', // Semi-transparent black for view window
    background: '#ffffff',     // White background
    timestamp: '#333333',      // Dark gray for timestamps
    eventColors: {
      10: 'rgba(255, 100, 100, 0.35)',  // CardiacPause - red
      20: 'rgba(255, 165, 0, 0.3)',     // Bradycardia - orange
      30: 'rgba(255, 0, 255, 0.3)',     // Tachycardia - magenta
      40: 'rgba(255, 200, 0, 0.35)',    // IrregularBeat - yellow
      default: 'rgba(128, 128, 128, 0.3)'
    },
    eventBorderColors: {
      10: 'rgba(200, 60, 60, 0.6)',     // CardiacPause border - darker red
      20: 'rgba(200, 130, 0, 0.6)',     // Bradycardia border - darker orange
      30: 'rgba(200, 0, 200, 0.6)',     // Tachycardia border - darker magenta
      40: 'rgba(200, 160, 0, 0.6)',     // IrregularBeat border - darker yellow
      default: 'rgba(80, 80, 80, 0.5)'
    },
  },
  lineWidth: {
    ecg: 1.5,         // ECG line width
    majorGrid: 0.5,   // Major grid line width
    minorGrid: 0.25,  // Minor grid line width
  }
};

// Helper function to get event color by type
export const getEventColor = (eventType) =>
  GRID_SPECS.colors.eventColors[eventType] || GRID_SPECS.colors.eventColors.default;

// Helper function to get event border color by type
export const getEventBorderColor = (eventType) =>
  GRID_SPECS.colors.eventBorderColors[eventType] || GRID_SPECS.colors.eventBorderColors.default;

// UI tweaks related to navigation and auxiliary controls
export const NAV_UI = {
  // Scale factor for body position icon near ECG controls
  bodyPositionScale: 0.7,
};
